<style lang="scss" scoped>
.male {
  background-color: $male;
}
.female {
  background-color: $female;
}
</style>

<template>
  <td :class="css" class="text-center text-lg p-1 text-white">
    <i v-if="male" class="fas fa-mars"></i>
    <i v-else class="fas fa-venus"></i>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
      male() {
        return this.content !== "weiblich";
      },
      css() {
        return this.male ? 'male' : 'female';
      }
    }
};
</script>
